export const ERROR_CODE = {
  TIMEOUT: "ECONNABORTED",
};
